<ion-header>
  <ion-toolbar mode="ios">
    <ion-title text-center>
      {{ selectOrder?.tradeType === "S" ? "Receive" : "Make" }} Payment
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon
          class="position-rule"
          slot="icon-only"
          name="close-circle"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content *ngIf="selectOrder || selectedOrders">
  <ion-card
    class="background-card no-box-shadow"
    *ngIf="selectedOrders?.length > 1"
  >
    <ion-grid no-padding="" class="d-flex order-details">
      <ion-row class="ion-nowrap" style="overflow-x: scroll">
        <div
          style="background-color: #ffffff; margin: 10px"
          *ngFor="let order of selectedOrders"
        >
          <ion-item class="background-style" input-item lines="none">
            <ion-label class="ion-text-uppercase" position="stacked"
              >Order Id</ion-label
            >
            <ion-text text-regular style="width: 100%" class="ion-float-left"
              >#{{ order?.formattedId }}</ion-text
            >
          </ion-item>
          <ion-item class="background-style" input-item lines="none">
            <ion-label class="ion-text-uppercase" position="stacked"
              >Bulk Generator Name</ion-label
            >
            <ion-text text-regular style="width: 100%">{{
              order?.seller?.firstName
            }}</ion-text>
          </ion-item>
          <ion-item class="background-style" input-item lines="none">
            <ion-label class="ion-text-uppercase" position="stacked"
              >Account Holder</ion-label
            >
            <ion-text
              text-regular
              style="width: 100%"
              *ngIf="selectOrder?.orderType !== 'DROP'"
              >{{
                order?.payment?.location?.customerPaymentAccount
                  ?.accountHolderName || "Not Available"
              }}</ion-text
            >
            <ion-text
              text-regular
              style="width: 100%"
              *ngIf="selectOrder?.orderType === 'DROP'"
              >{{
                order?.seller?.paymentAccountDTO?.accountHolderName ||
                  "Not Available"
              }}</ion-text
            >
          </ion-item>
          <div style="margin-bottom: 10px"></div>
        </div>
      </ion-row>
    </ion-grid>
  </ion-card>
  <ion-card
    class="background-card no-box-shadow"
    *ngIf="selectOrder?.payment?.orderPaymentStatus === 'PAYMENT_PENDING'"
  >
    <ion-grid no-padding="">
      <ion-row>
        <ion-col size="6">
          <ion-item class="background-style" input-item lines="none">
            <ion-label class="ion-text-uppercase" position="stacked"
              >PickupId</ion-label
            >
            <ion-text text-regular style="width: 100%" class="ion-float-left"
              >#{{ selectOrder?.formattedId }}</ion-text
            >
          </ion-item>
          <ion-item
            class="background-style"
            input-item
            lines="none"
            *ngIf="selectOrder?.tradeType === 'B'"
          >
            <ion-label class="ion-text-uppercase" position="stacked"
              >Account Number</ion-label
            >
            <ion-text
              text-regular
              style="width: 100%"
              *ngIf="selectOrder?.orderType !== 'DROP'"
              >{{
                selectOrder?.payment?.location?.customerPaymentAccount
                  ?.accountNumber || "Not Available"
              }}</ion-text
            >
            <ion-text
              text-regular
              style="width: 100%"
              *ngIf="selectOrder?.orderType === 'DROP'"
              >{{
                selectOrder?.seller?.paymentAccountDTO?.accountNumber ||
                  "Not Available"
              }}</ion-text
            >
          </ion-item>
          <ion-item
            class="background-style"
            input-item
            lines="none"
            *ngIf="selectOrder?.tradeType === 'B'"
          >
            <ion-label class="ion-text-uppercase" position="stacked"
              >Account Holder</ion-label
            >
            <ion-text
              text-regular
              style="width: 100%"
              *ngIf="selectOrder?.orderType !== 'DROP'"
              >{{
                selectOrder?.payment?.location?.customerPaymentAccount
                  ?.accountHolderName || "Not Available"
              }}</ion-text
            >
            <ion-text
              text-regular
              style="width: 100%"
              *ngIf="selectOrder?.orderType === 'DROP'"
              >{{
                selectOrder?.seller?.paymentAccountDTO?.accountHolderName ||
                  "Not Available"
              }}</ion-text
            >
          </ion-item>
        </ion-col>
        <ion-col size="6">
          <ion-item class="background-style" input-item lines="none">
            <ion-label class="ion-text-uppercase" position="stacked"
              >Bulk Generator Name</ion-label
            >
            <ion-text text-regular style="width: 100%">{{
              selectOrder?.seller?.firstName
            }}</ion-text>
          </ion-item>
          <ion-item
            class="background-style"
            input-item
            lines="none"
            *ngIf="selectOrder?.tradeType === 'B'"
          >
            <ion-label class="ion-text-uppercase" position="stacked"
              >Bank/Branch</ion-label
            >
            <ion-text
              text-regular
              style="width: 100%"
              *ngIf="selectOrder?.orderType !== 'DROP'"
              >{{
                selectOrder?.payment?.location?.customerPaymentAccount?.bank ||
                  "Not Available"
              }}
              /
              {{
                selectOrder?.payment?.location?.customerPaymentAccount
                  ?.branch || "Not Available"
              }}
            </ion-text>
            <ion-text
              text-regular
              style="width: 100%"
              *ngIf="selectOrder?.orderType === 'DROP'"
            >
              {{
                selectOrder?.seller?.paymentAccountDTO?.bank || "Not Available"
              }}
              /
              {{
                selectOrder?.seller?.paymentAccountDTO?.branch ||
                  "Not Available"
              }}</ion-text
            >
          </ion-item>

          <ion-item
            class="background-style"
            input-item
            lines="none"
            *ngIf="selectOrder?.tradeType === 'B'"
          >
            <ion-label class="ion-text-uppercase" position="stacked"
              >IFSC</ion-label
            >
            <ion-text
              text-regular
              style="width: 100%"
              *ngIf="selectOrder?.orderType !== 'DROP'"
              >{{
                selectOrder?.payment?.location?.customerPaymentAccount?.ifsc ||
                  "Not Available"
              }}</ion-text
            >
            <ion-text
              text-regular
              style="width: 100%"
              *ngIf="selectOrder?.orderType === 'DROP'"
              >{{ selectOrder?.seller?.paymentAccountDTO?.ifsc }}</ion-text
            >
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
  <ion-grid>
    <form [formGroup]="paymentForm" name="paymentForm">
      <ion-row>
        <ion-col size="6">
          <ion-item input-item lines="none">
            <ion-label position="stacked" font-medium=""
              >Amount
              {{
                selectOrder?.tradeType === "S" ? "Received" : "Paid"
              }}*</ion-label
            >
            <ion-input
              type="number"
              inputmode="text"
              formControlName="amountPaid"
              name="amountPaid"
            ></ion-input>
          </ion-item>
        </ion-col>

        <ion-col size="6">
          <ion-label position="stacked" font-medium="" class="label-position"
            >Payment Mode*</ion-label
          >
          <div>
            <p-dropdown
              [options]="paymentOptions"
              optionLabel="name"
              formControlName="paymentMode"
              name="paymentMode"
            ></p-dropdown>
          </div>
        </ion-col>

        <ion-col size="6">
          <ion-item input-item="" lines="none">
            <ion-label position="stacked" font-medium="">Ref.No*</ion-label>
            <ion-input
              inputmode="text"
              type="text"
              formControlName="refNo"
              name="refNo"
            ></ion-input>
          </ion-item>
        </ion-col>

        <ion-col size="6">
          <ion-item input-item="" lines="none">
            <ion-label position="stacked" font-medium=""
              >Payment Date*</ion-label
            >
            <ion-input readonly="" (click)="datepicker.open()"
              >&nbsp; {{ sDate | date: "dd/MM/yyyy" }}
              <ion-icon
                name="calendar"
                slot="end"
                float-right=""
                style="position: absolute; right: 5px"
              ></ion-icon>
            </ion-input>
            <ion-datetime
              displayFormat="YYYY-MM-DD"
              hidden="true"
              mode="ios"
              placeholder="Select Date"
              value="sDate"
              [(ngModel)]="sDate"
              #datepicker
              [ngModelOptions]="{ standalone: true }"
            ></ion-datetime>
          </ion-item>
        </ion-col>
        <ion-col size="12">
          <ion-item input-item="" lines="none">
            <ion-textarea
              font-medium=""
              type="text"
              placeholder="Comments"
              formControlName="comment"
              name="comment"
            ></ion-textarea>
          </ion-item>
        </ion-col>
      </ion-row>
    </form>
  </ion-grid>
</ion-content>
<ion-footer no-box-shadow="" text-center>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-button
          size="large"
          recykal-button=""
          style="width: 90%"
          [disabled]="!paymentForm?.valid"
          color="primary"
          class="ion-margin-bottom"
          (click)="savePayment()"
          >Confirm Payment
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
